export default __webpack_public_path__ + "static/media/Helm of the Tireless Defender.a29593cb.jpg";